<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">
          {{ appName }}
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <!-- <b-img fluid :src="imgUrl" alt="Login V2" /> -->
          <div class="fly-layer">
            <div class="layer-image">
              <div class="parallax-ball">
                <img class="animate3" src="@/assets/images/slider/ball1.png" width="50px" alt="img">
              </div>
              <div class="animate4">
                <img src="@/assets/images/slider/h1-layer1.png" width="600px" alt="Slider Layer Image">
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            欢迎来到 {{ appName }}! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            请登录您的账号开启竞猜之旅吧！
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- username -->
              <b-form-group label="登录用户" label-for="login-username">
                <validation-provider #default="{ errors }" name="登录用户" rules="required">
                  <b-form-input id="login-username" v-model="username" :state="errors.length > 0 ? false : null"
                    name="login-username" placeholder="请输入用户名" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">登录密码</label>
                  <!-- <b-link :to="{ name: 'auth-forgot-password-v2' }">
                    <small>Forgot Password?</small>
                  </b-link> -->
                </div>
                <validation-provider #default="{ errors }" name="Password" rules="required">
                  <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                    <b-form-input id="login-password" v-model="password" :state="errors.length > 0 ? false : null"
                      class="form-control-merge" :type="passwordFieldType" name="login-password"
                      placeholder="············" />
                    <b-input-group-append is-text>
                      <feather-icon class="cursor-pointer" :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox id="rememberme" v-model="rememberme" name="checkbox-1">
                  记住密码
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button type="submit" variant="primary" block @click="validationForm">
                登录
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span>没有账户? </span>
            <b-link :to="{ name: 'register' }">
              <span>&nbsp;立即注册</span>
            </b-link>
          </b-card-text>

          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">
              联系我们
            </div>
          </div>

          <!-- social buttons -->
          <div class="auth-footer-btn d-flex justify-content-center">
            <!-- <b-avatar
              size="20"
              src="@/assets/images/register/alpay.png"
            /> -->

            <b-button variant="facebook" href="javascript:void(0)" v-b-popover.hover.top="'footballprediction88'"
              title="请添加微信号：">
              <!-- <b-avatar size="15" src="@/assets/images/register/wechat.png" /> -->
              <!-- <feather-icon icon="FacebookIcon" /> -->
              <img src="@/assets/images/register/wechat.png" width="16" height="16" alt="qr-code1" />
            </b-button>
            <b-button variant="facebook" href="javascript:void(0)" v-b-popover.hover.top="'296682978'" title="请添加QQ：">
              <b-avatar size="15" src="@/assets/images/register/qq.png" />
              <!-- <img src="@/assets/images/register/qq.png" width="16" height="16" alt="qr-code2" -->
              <!-- <feather-icon icon="FacebookIcon" /> -->
            </b-button>
          </div>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import request from '@/utils/request.js';
import { $themeConfig } from '@themeConfig'


export default {
  components: {
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      rememberme: '',
      password: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      username: '',
    }
  },
  mounted() {
    this.username = localStorage.getItem('soccer_username');
    this.password = localStorage.getItem('soccer_password');
    this.rememberme = localStorage.getItem('soccer_rememberme');
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.login();
        }
      })
    },

    //当前登录按钮操作
    login() {
      var post_url = 'football/admin/william/interfaceAction!login.action'
      post_url += '?userName=' + this.username + '&password=' + this.password;
      let opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      this.loading = true;
      request.openHttpRequest(opts).then(response => {
        this.loading = false;
        if (response == null) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: '网络错误',
              icon: 'EditIcon',
              variant: 'danger',
            },
          })

          return;
        }

        if (response.status == 200) {

          if (response.data.status == 4) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: '当前用户付款状态未更新。如果您已付款，请耐心等待系统确认付款状态;如果您还没付款，请先进行付款。',
                icon: 'EditIcon',
                variant: 'warning',
              },
            })
            return;
          }

          if (response.data.status == 2) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: '抱歉，您的会员已到有效期',
                icon: 'EditIcon',
                variant: 'warning',
              },
            })

            return;
          }
          if (response.data.status == 0) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: 'EditIcon',
                variant: 'warning',
              },
            })
            return;
          }


          // 存储数据到本地缓存

          localStorage.setItem('soccer_username', this.username);
          localStorage.setItem('soccer_password', this.password);
          localStorage.setItem('soccer_token', response.data.token);
          localStorage.setItem('soccer_rememberme', this.rememberme);

          this.$router.push('/Dashboards');

          var post_url =
            '/AI/count?route=' + '登录系统_'+this.username;
          let opts = {
            type: 1, //1为数据接口；2为静态资源请求
            url: post_url,
            method: 'get'
          };
          request.openHttpRequest(opts).then(res => { });
        }
      });
    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
